import { IconCheck, IconChevronDown, IconSearch, IconTrash, IconX } from "@tabler/icons"
import { ChangeEvent } from "react"
import { Dropdown } from "../../Dropdown"
import { Input } from "../../Input"
import { useCreateFolder } from "../utils/index"
import { FileTypes } from "./Gallery"

interface HeaderProps {
  files: Array<FileTypes>
  selectedFiles: Array<number>
  setSelectedFiles: (selectedFiles: Array<number>) => void
  handleUpdateFolder: (e: { value: string, label: string }, selectedFiles: Array<number>) => void
  moveOptions: Array<{ value: string, label: string }>
  currentFolderId: string | number
  handleDelete: (selectedFiles: Array<number>) => void
  search: string
  setSearch: (search: string) => void
  siteId: string | number
}

const Header = ({
  files,
  selectedFiles,
  setSelectedFiles,
  handleUpdateFolder,
  moveOptions,
  handleDelete,
  search,
  setSearch,
  siteId
}: HeaderProps) => {
  const [ createFolder ] = useCreateFolder()
  return (
    <div className='flex justify-between items-center mt-3 mb-2 h-[8%]'>
      <div>
        {
          files.length > 0 &&
          <label className="inline-flex items-center">
            <input
              type="checkbox"
              className="form-checkbox h-4 w-4 bg-transparent"
              checked={!!files.length && selectedFiles.length === files.length}
              onChange={(e) => {
                if (e.target.checked) {
                  setSelectedFiles(files.map((item) => item.id || -1))
                } else {
                  setSelectedFiles([])
                }
              }}
            />
            <span className="ml-2 font-light">Select All</span>
          </label>
        }
      </div>
      <div className='flex justify-end items-center w-[60%]'>
        {
          selectedFiles.length > 0 ?
            <>
              <div className="mr-[8px] flex items-center">
                <Dropdown
                  component={
                    <div className={`text-base text-secondary capitalize w-[150px] h-[32px] py-[7px] px-[16px] justify-between bg-gray-400 flex items-center rounded-[4px] ${!moveOptions.length && 'pointer-events-none opacity-50'}`} >
                      Move to Folder
                      <IconChevronDown size="16px" className="ml-[8px]" />
                    </div>}
                  action="primary"
                  value={'Move'}
                  alignLeft={true}
                  width={'200px'}
                  callback={(e: { value: string, label: string }) => {
                    if(e.value === 'newFolder') {
                      createFolder(siteId, handleUpdateFolder, selectedFiles)
                    } else {
                      handleUpdateFolder(e, selectedFiles)
                    }
                  }}
                  autoAdjustBottom={false}
                  maxHeight={'max-h-[200px]'}
                  scrollHint
                  portaled
                  portalZIndex={1000001}
                  options={moveOptions}
                  disabled={!moveOptions.length}
                />
              </div>
              <Dropdown
                component={<IconTrash className='text-danger' size="24px" stroke={1.5} />}
                action="primary"
                value={'Delete Files'}
                options={[{ value: 'confirm', label: 'Confirm', noHoverEffect: true, ctaIcon: <div className='flex'><span className='p-1 bg-primary-lighter cursor-pointer' onClick={(e) => handleDelete(selectedFiles)}><IconCheck size={18} /></span><span className='p-1 bg-danger-lighter ml-1 cursor-pointer'><IconX size={18} /></span></div>, ctaIconClick: (e: any) => { } }]}
                width={'170px'}
                autoAdjustBottom={false}
                maxHeight={'max-h-[80px]'}
                alignLeft={true}
                noWidth={true}
              />
            </>
            :
            <Input
              icon={<IconSearch size="16px" color="#2E384D" />}
              placeholder="Search"
              type="text"
              value={search}
              onChange={(e: ChangeEvent<HTMLInputElement>) => setSearch(e.target.value)}
            />
        }
      </div>
    </div>
  )
}

export default Header